import PazienteConsensi from "../";

const routes = [
    { name: "PazienteConsensiList", path: "/paziente/consensi", component: PazienteConsensi.PazienteConsensiList, meta: { title: "Paziente Consensi" } },
];

export default routes;
